import { EModule, ETabItem } from './types';
// eslint-disable-next-line import/prefer-default-export
export var ALL_SHORTCUTS = [{
  module: EModule.ContainerChat,
  shortcut: 'chatsUnread',
  headerTabItem: ETabItem.Chat
}, {
  module: EModule.ContainerTableAppointments,
  shortcut: 'schedule',
  headerTabItem: ETabItem.Schedule
}, {
  module: EModule.ContainerTableDocuments,
  shortcut: 'intake',
  headerTabItem: ETabItem.Intake
}, {
  module: EModule.ContainerTableReferralsInbound,
  shortcut: 'referrals',
  headerTabItem: ETabItem.ReferralsInbound
}, {
  module: EModule.ContainerChat,
  shortcut: 'chatsUnassigned',
  headerTabItem: ETabItem.Chat
}, {
  module: EModule.ContainerTableWaitlists,
  shortcut: 'waitlists',
  headerTabItem: ETabItem.Waitlists
}, {
  module: EModule.ContainerTableBroadcasts,
  shortcut: 'broadcasts',
  headerTabItem: ETabItem.Broadcasts
}, {
  module: EModule.ContainerTableReferralsOutbound,
  shortcut: 'outbound-referrals',
  headerTabItem: ETabItem.ReferralsOutbound
}, {
  module: EModule.ContainerInsightsOverview,
  shortcut: 'insights-center',
  headerTabItem: ETabItem.Insights
}, {
  module: EModule.ContainerTableLumaPay,
  shortcut: 'luma-pay',
  headerTabItem: ETabItem.LumaPay
}, {
  module: EModule.ContainerTablePatientJourney,
  shortcut: 'patient-journeys',
  headerTabItem: ETabItem.PatientJourney
}, {
  module: EModule.ContainerProviderUtilization,
  shortcut: 'provider-utilization',
  headerTabItem: ETabItem.ProviderUtilization
}, {
  module: EModule.ContainerTableRecalls,
  shortcut: 'recalls',
  headerTabItem: ETabItem.Recalls
}, {
  module: EModule.ContainerReports,
  shortcut: 'reports',
  headerTabItem: ETabItem.Reports
}, {
  module: EModule.ContainerInsightsCenterReports,
  shortcut: 'insights-center-reports',
  headerTabItem: ETabItem.InsightsReports
}, {
  module: EModule.ContainerStaffScheduler,
  shortcut: 'scheduler-assist',
  headerTabItem: ETabItem.SchedulerAssist
}, {
  module: EModule.ContainerWaitingRoom,
  shortcut: 'waiting-room',
  headerTabItem: ETabItem.WaitingRoom
}];